import {
    CreateMatchOfficialCommandOfMatchOfficial,
    CreateOrUpdateMatchOfficialsCommand,
    MatchOfficialVm,
    MatchesClient,
} from '../../utils/api';
import { BatchOfficialsApplyMode, OfficialRolePair } from './BatchMatchOfficialsDrawer';

export async function applyBatchOfficialsToMatches(
    matchIds: number[],
    pairs: OfficialRolePair[],
    mode: BatchOfficialsApplyMode
): Promise<{ ok: number; failed: number }> {
    const client = new MatchesClient();

    const settled = await Promise.allSettled(
        matchIds.map(async (mid: number) => {
            let merged: CreateMatchOfficialCommandOfMatchOfficial[];

            if (mode === 'replace') {
                merged = pairs.map(
                    (p: OfficialRolePair) =>
                        new CreateMatchOfficialCommandOfMatchOfficial({
                            id: 0,
                            matchId: mid,
                            officialId: p.officialId,
                            roleId: p.roleId,
                        })
                );
            } else {
                const detail = await client.getById(mid);
                const existingVms = detail.officials || [];
                merged = existingVms.map(
                    (mo: MatchOfficialVm) =>
                        new CreateMatchOfficialCommandOfMatchOfficial({
                            id: mo.id ?? 0,
                            matchId: mo.matchId ?? mid,
                            officialId: mo.officialId,
                            roleId: mo.roleId,
                        })
                );

                for (const p of pairs) {
                    const dup = merged.some(
                        (e: CreateMatchOfficialCommandOfMatchOfficial): boolean =>
                            e.officialId === p.officialId && e.roleId === p.roleId
                    );
                    if (!dup) {
                        merged.push(
                            new CreateMatchOfficialCommandOfMatchOfficial({
                                id: 0,
                                matchId: mid,
                                officialId: p.officialId,
                                roleId: p.roleId,
                            })
                        );
                    }
                }
            }

            const cmd = new CreateOrUpdateMatchOfficialsCommand({
                matchId: mid,
                matchOfficials: merged,
            });
            await client.updateOfficials(mid, cmd);
        })
    );

    const failed = settled.filter((s) => s.status === 'rejected').length;
    const ok = settled.length - failed;
    return { ok, failed };
}
